import {
    Nav,
    NavLink,
    Bars,
    NavMenu,
} from "./navbarElements";
import './navbar.css';
import GoogleProfile from '../components/GoogleProfile';
import { Link } from 'react-router-dom';

const logoSrc = `${process.env.PUBLIC_URL}/JAM_logo.png`;

function Navbar() {
    return(
        <div className='Navbar'>
            <div className='left-btns'>
                <Link to="/" className="nav-logo-link" aria-label="JAM home">
                    <img src={logoSrc} alt="" className="nav-logo-img" />
                </Link>
                <Nav className="nav-inner">
                    <Bars />
                    <NavMenu>
                        <NavLink to='/'>
                            Home
                        </NavLink>
                        <NavLink to="/dashboard">
                            Dashboard
                        </NavLink>
                        <NavLink to="/add-application">
                            Add Application
                        </NavLink>
                        <NavLink to="/about">
                            About
                        </NavLink>
                    </NavMenu>
                </Nav>
            </div>
            <div className='right-btns'>
                <GoogleProfile />
            </div>
        </div>
    );
}

export default Navbar
